// extracted by mini-css-extract-plugin
export var adaptiveBlock = "seoCard-module--adaptiveBlock--fIOct";
export var btnGroup = "seoCard-module--btnGroup--tlNpk";
export var btnPrimary = "seoCard-module--btnPrimary--mc5Eq";
export var btnSecondary = "seoCard-module--btnSecondary--nz7mn";
export var card = "seoCard-module--card--Yj9sQ";
export var description = "seoCard-module--description--eGizf";
export var hidden = "seoCard-module--hidden--p0bAR";
export var img = "seoCard-module--img--t1drZ";
export var textBlock = "seoCard-module--textBlock--Yux5f";
export var title = "seoCard-module--title--0Eio+";